/* global translations */
import React from 'react';
import get from 'lodash/get';
import { ImageSvg } from '../image';

const PaymentSuccess = () => (
  <div className="paymentContainer paymentContainer--success">
    <div className="paymentContainer-successIcon mbl">
      <ImageSvg svg="icon-check-2" iconClass="icon--check-2" full />
    </div>
    <div className="paymentContainer-title mbs">
      {get(translations, 'txt: Apmaksa notikusi veiksmīgi!', '')}
    </div>
  </div>
);

export default PaymentSuccess;
